import { Observable } from 'rxjs/Observable';

// Interfaces
import { LocatorInterface } from './locator.interface'

// Providers.
import { RequestedItems } from '../wa-services/param-builder-service'

// Classes.
import { Metadata } from '../db/data-container';



export class ViewDataConfigStruct {
  constructor(
    public maxAge: number = 600, // 600 seconds, 10 minutes.
    public interval: number = 1000, // 1000 milliseconds, 1 second.
    public autorefresh: boolean = true,
    public expectedItems: RequestedItems = 10
  ) { };
}


/**
 * Interface for view data.
 *
 */

export interface ViewDataInterface {

  locator: LocatorInterface;

  updatedTimestamp: number;

  totalItems: number;

  availableItems: number;

  resfreshInterval: number;

  autorefresh: boolean;

  metadata: Metadata;

  init(): void;

  refresh(): void;

  updateData(): void;

  getDataStream(): Observable<any>;

  getDataAvailableStream(): Observable<boolean>;

  applyConfiguration(confToApply: ViewDataConfigStruct): void;

  incrementExpectedItemNumber(qty: number): void;

  setExpectedItemNumber(qty: number): void;

  addDependency(dependency: ViewDataInterface): void;

  connectDependencies(): void;

  deleteContent(): void
}